import React, { useState, useEffect, useRef } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { fetchDefault, fetchPostDefault } from './Utils.js';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { useHistory } from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';

const useStyles = makeStyles(theme => ({
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
        },
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(1, 0, 1),
    },
    backAbsolute: {
        position: 'fixed',
        bottom: theme.spacing(5),
        right: theme.spacing(5),
    },
}));

const useFocus = () => {
    const htmlElRef = useRef(null)
    const setFocus = () => { htmlElRef.current && htmlElRef.current.focus() }

    return [htmlElRef, setFocus]
}

export default function SignIn() {;
    const classes = useStyles();
    let history = useHistory();

    const [btnRef, setBtnFocus] = useFocus();

    const [smsCode, setSmsCode] = React.useState('');

    const [changeId, setChangeId] = React.useState('');


    const [currentPassword, setCurrentPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');
    const [passwordErrorText, setPasswordErrorText] = React.useState('');
    const [passwordConfirmErrorText, setPasswordConfirmErrorText] = React.useState('');

    const [errorOpen, setErrorOpen] = React.useState(false);
    const [changePwOpen, setChangePwOpen] = React.useState(false);
    

    const [phoneNumber, setPhoneNumber] = React.useState('010');
    const [phoneErrorText, setPhoneErrorText] = React.useState('');



    const [memberList, setMemberList] = React.useState();


    const validatePassword = (event) => {

        setCurrentPassword(event.target.value);

        //패스워드 확인 부분
        if (currentPassword.length > 0 && confirmPassword.length > 0 && event.target.value === confirmPassword) {
            setPasswordConfirmErrorText('');
        } else if (currentPassword.length > 0 && confirmPassword.length > 0 && event.target.value !== confirmPassword) {
            setPasswordConfirmErrorText('비밀번호가 동일하지 않습니다.');
        }

        if (event.target.value.length < 1) {
            setPasswordErrorText('비밀번호를 입력해주세요.');
        }
        else if (event.target.value.length < 4) {
            setPasswordErrorText('비밀번호는 4자리 이상으로 설정해주세요');
        }
        else {
            setPasswordErrorText('');
        }
    };


    const validatePasswordConfirm = (event) => {

        setConfirmPassword(event.target.value)

        if (currentPassword !== event.target.value) {
            setPasswordConfirmErrorText('비밀번호가 동일하지 않습니다.');
        } else {
            setPasswordConfirmErrorText('');
        }
    };


    const validatePhone = (event) => {
        if (event.target.value.length < 10) {
            setPhoneErrorText('핸드폰 번호를 확인해주세요.');
        } else {
            setPhoneErrorText('');
        }
    };

    const setOnlyNumber = (event) => {

        setPhoneNumber((event.target.validity.valid && event.target.value.length < 12) ? event.target.value : phoneNumber);

        if (event.target.value.length == 11) {
            setBtnFocus();
        }
    };


    const getSMSCode = (event) => {

        event.preventDefault();

        fetchDefault('/User/GetSMSCode?phone='+ phoneNumber,
            (data) => {
                alert('인증번호가 전송되었습니다.');
            }
        );
    };


    const checkSMSCode = () => {

        fetchDefault('/User/CheckSMSCode?phone=' + phoneNumber + '&smsCode=' + smsCode,
            (data) => {
                setMemberList(data);
                //window.location.assign('/');
            }
        );
    };


    const openChangePassword = (id) => {

        setChangeId(id);
        setChangePwOpen(true);

    };

    const changePassword = () => {

        if (currentPassword !== confirmPassword) {
            alert('비밀번호가 동일하지 않습니다.');
            return;
        }

        setChangePwOpen(false);

        fetchDefault('/User/ChangePassword?id=' + changeId + '&password=' + currentPassword,
            (data) => {
                alert('변경이 완료되었습니다.');
                window.location.assign('/signIn');
            }
        );
    };


    useEffect(() => {
        const pageTimeout = setTimeout(() => {
            history.push('/display/connected');
        }, 240000);

        return () => {
            clearTimeout(pageTimeout);
        }
    }, []);

    return (
        <Container component="main" maxWidth="xs">



            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5" style={{ marginTop:10, marginBottom:20 }}>
                    아이디/비밀번호 찾기
                </Typography>

                    <TextField
                        onBlur={validatePhone}
                        onChange={setOnlyNumber}
                        variant="outlined"
                        fullWidth
                        id="phone"
                        label="회원가입된 핸드폰 번호('-' 빼고 숫자만 입력)"
                        name="phone"
                        type="number"
                        inputProps={{ pattern: "[0-9]*" }}
                        value={phoneNumber}
                        error={phoneErrorText.length === 0 ? false : true}
                        helperText={phoneErrorText}
                    >
                    </TextField>

                    <Button
                        onClick={getSMSCode}
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        문자로 인증번호 받기
                    </Button>


                    <TextField
                        onChange={(event) => setSmsCode(event.target.value)}
                        variant="outlined"
                        fullWidth
                        id="inputCode"
                        label="전송된 인증번호를 입력해주세요."
                        name="inputCode"
                        style={{marginTop:15}}
                    />

                    <Button
                        onClick={checkSMSCode}
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        인증번호 확인
                    </Button>

                
                    {memberList ? (
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                {memberList.map(m => (
                                    <Card style={{ marginBottom: 5 }}>
                                        <CardContent>
                                            <Typography variant="body1">
                                                아이디 : {m.loginId}
                                            </Typography>
                                            <Typography variant="body1">
                                                잔액 : {m.point}
                                            </Typography>
                                        </CardContent>
                                        <CardActions>
                                            <Button onClick={() => openChangePassword(m.id)}>
                                                비밀번호 변경
                                            </Button>
                                        </CardActions>
                                    </Card>
                                ))}
                            </Grid>
                        </Grid>
                    ) : (<Grid></Grid>)}

            </div>
            <Box mt={8}>
                
            </Box>


            <Dialog
                open={errorOpen}

                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <Typography variant="h6" color="textPrimary">
                        아이디 또는 비밀번호를 확인하세요.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="primary">
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={errorOpen}
                onClose={()=>setErrorOpen(false)}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <Typography variant="h6" color="textPrimary" style={{ marginTop: 20 }}>
                        아이디 또는 비밀번호를 확인하세요.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => setErrorOpen(false)}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={changePwOpen}
                onClose={() => setChangePwOpen(false)}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>

                    <Grid item xs={12}>
                        <TextField
                            onBlur={validatePassword}
                            onChange={(event) => setCurrentPassword(event.target.value)}
                            variant="outlined"
                            required
                            fullWidth
                            margin="normal"
                            name="password"
                            label="비밀번호"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            error={passwordErrorText.length === 0 ? false : true}
                            helperText={passwordErrorText}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            onBlur={validatePasswordConfirm}
                            variant="outlined"
                            required
                            fullWidth
                            margin="normal"
                            name="passwordConfirm"
                            label="비밀번호 확인"
                            type="password"
                            id="passwordConfirm"
                            autoComplete="current-password"
                            error={passwordConfirmErrorText.length === 0 ? false : true}
                            helperText={passwordConfirmErrorText}
                        />
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => changePassword()}>
                        <Typography variant="h6">
                            변경하기
                        </Typography>
                    </Button>
                    <Button color="primary" onClick={() => setChangePwOpen(false)}>
                        <Typography variant="h6">
                            취소
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
}


// WEBPACK FOOTER //
// ./src/components/FindIdPw.js